//import React from 'react'
import { Link } from 'react-router-dom'
import Card from '../components/Card'

export default function Profile() {
  //const { id } = useParams()
  //let newID = id;
  return (
    <div className="container">
      <section className="card" style={{display:'flex', gap:18, alignItems:'flex-start'}}>
        <div style={{minWidth:220}}>
          <div style={{width:180, height:180, borderRadius:12, overflow:'hidden', background:'#f1f6ff'}} />
          <div style={{marginTop:12}} className="kv">Verified • 6 years experience</div>
        </div>

        <div style={{flex:1}}>
          <h2 style={{margin:0}}>Sarah P. <span className="kv">• CPA</span></h2>
          <div className="kv" style={{marginTop:8}}>Specialties: Taxes, QuickBooks, Small Business</div>

          <div style={{display:'flex', gap:12, marginTop:16}}>
            <Card style={{flex:'0 0 160px', textAlign:'center'}}>
              <div style={{fontWeight:700, fontSize:18}}>★ 5.0</div>
              <div className="kv">100 reviews</div>
            </Card>

            <Card style={{flex:'0 0 160px', textAlign:'center'}}>
              <div style={{fontWeight:700, fontSize:18}}>$45/hr</div>
              <div className="kv">Hourly rate</div>
            </Card>

            <div style={{marginLeft:'auto', display:'flex', gap:8, alignItems:'center'}}>
              <Link to="/dashboard" className="btn primary">Request service</Link>
              <Link to="/messages" className="btn ghost">Message</Link>
            </div>
          </div>

          <div style={{marginTop:18}}>
            <h3 className="h2">About</h3>
            <p className="kv">Sarah has 6 years of experience helping small businesses with monthly bookkeeping, payroll, tax prep and QuickBooks setup.</p>

            <h3 className="h2" style={{marginTop:14}}>Reviews</h3>
            <Card>
              <div style={{fontWeight:700}}>“Saved us hours every month”</div>
              <div className="kv">– Marcus, CEO of Foundry</div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  )
}
